module.exports = __webpack_public_path__ + "static/media/crown.27b167d8.svg";